import { computed, ref } from "vue";
import type {
  GetPrefByChainQuery,
  ListDeliveryAreaQuery,
  ListMemberQuery,
} from "@/generated/graphql";
import shopStore from "@/store/shopStore";
import type { DeliveryAvailabilityData, MemberData } from "../types";

/**
 * 配達依頼登録開始画面の状態を扱う composable。
 */
export const useDeliveryRequestRegisterStartState = () => {
  // 新規会員/既存会員入力エリアの基本状態
  const btnNonMemberToggle = ref<number>(0);
  const prefSelectValue = ref<unknown>("");
  const phone_number = ref<string>("");
  const user_name = ref<string>("");
  const house_card = ref<string>("");
  const userErrorMessage = ref<string>("");
  const zip_code = ref<string>("");
  const errorZipCode = ref<string>("");
  const errorPrefSelect = ref<string>("");
  const wordList = ref<Record<string, string>>({});
  const dialog = ref<boolean>(false);
  const overlay = ref<boolean>(false);
  const messagedialog = ref<boolean>(false);
  const message = ref<string>("");
  const uploadDialog = ref<boolean>(false);
  const btnDisabled = ref<boolean>(true);
  const getAvailableDate = ref<string>("");

  // マスタ・検索結果
  const prefListItems = ref<
    (GetPrefByChainQuery["getPrefByChain"][number] | null)[]
  >([]);
  const listMemberResult = ref<
    (ListMemberQuery["listMember"][number] | null)[]
  >([]);
  const memberData = ref<MemberData[]>([]);

  // 配達便表示用データ
  const deliveryAvailabilityHeader = ref<Map<string, string>>(new Map());
  const deliveryAvailabilityData = ref<DeliveryAvailabilityData[][]>([]);
  const deliveryAvailabilityStore = ref<DeliveryAvailabilityData[][]>([]);

  // エリア選択
  const areaListItems = ref<
    (ListDeliveryAreaQuery["listDeliveryArea"][number] | null)[]
  >([]);
  const areaSelectValues = ref<{ area_code: string; area_name: string }>({
    area_code: "",
    area_name: "",
  });

  // チェーン設定/会員検索補助情報
  const house_card_display = ref<number>(0);
  const is_hide_other_shop_members = ref<number>(0);
  const tmp_member_registration_flg = computed(
    () => shopStore.getTmpMemberRegistrationFlg
  );
  const use_receipt_barcode_search_flg = ref<number>(0);
  // レシートバーコードへのフォーカス完了前に他項目の操作を抑止するためのフラグ
  const isReceiptBarcodeFocusing = ref<boolean>(false);
  const receipt_barcode = ref<string>("");
  const receipt_barcode_house_card = ref<string>("");
  const register_no = ref<number>(0);
  const receipt_no = ref<number>(0);
  const payment_amount = ref<number>(0);

  // DOM参照
  const fileInput = ref<HTMLInputElement | null>(null);
  const fileInputdelivery = ref<HTMLInputElement | null>(null);
  const receipt_barcode_input = ref<{ focus?: () => void } | null>(null);

  return {
    btnNonMemberToggle,
    prefSelectValue,
    phone_number,
    user_name,
    house_card,
    userErrorMessage,
    zip_code,
    errorZipCode,
    errorPrefSelect,
    wordList,
    dialog,
    overlay,
    messagedialog,
    message,
    uploadDialog,
    btnDisabled,
    getAvailableDate,
    prefListItems,
    listMemberResult,
    memberData,
    deliveryAvailabilityHeader,
    deliveryAvailabilityData,
    deliveryAvailabilityStore,
    areaListItems,
    areaSelectValues,
    house_card_display,
    is_hide_other_shop_members,
    tmp_member_registration_flg,
    use_receipt_barcode_search_flg,
    isReceiptBarcodeFocusing,
    receipt_barcode,
    receipt_barcode_house_card,
    register_no,
    receipt_no,
    payment_amount,
    fileInput,
    fileInputdelivery,
    receipt_barcode_input,
  };
};
